import customerInvoices from './index.js';

const SET_INVOICES = (state, invoices)=>{
  state.invoices = invoices;
}

const SET_LOADING = (state, loading)=>{
  state.loading = loading;
}

const SET_CUSTOMER_ID = (state, customerId)=>{
  state.customerId = customerId;
}

const SET_SELECTED_INVOICES = (state, selectedInvoices)=>{
  state.selectedInvoices = selectedInvoices;
}

const ADD_INVOICE_TO_SELECTION = (state, invoice) =>{
  state.selectedInvoices.push(invoice);
}

const REMOVE_INVOICE_TO_SELECTION = (state, index) =>{

  state.selectedInvoices.splice(index,1);
  if (_.size(state.selectedInvoices) === 0) {
    state.portausCompanyId = null; // Reset portausCompanyId if no invoices are selected
  }
}

const SET_SELECT_ATTRIBUTE = (state, {index, selected}) =>{
  state.invoices[index].selected = selected
}

const CLEAR_SELECTED_INVOICES = (state) =>{
  _.forEach(state.selectedInvoices, i=>{i.selected = false});
  state.selectedInvoices = [];
  state.portausCompanyId = null;
}

const SET_LOADING_STATS = (state, loading) => {
  state.loadingStats = loading;
}

const SET_BALANCE = (state, balance) => {
  state.stats.balance = balance;
}

const SET_CREDIT = (state, credit) => {
  state.stats.credit = credit;
}

const SET_PORTAUS_COMPANY_ID = (state, portausCompanyId) => {
  state.portausCompanyId = portausCompanyId;
}

export default {
  SET_INVOICES,
  SET_LOADING,
  SET_CUSTOMER_ID,
  SET_SELECTED_INVOICES,
  ADD_INVOICE_TO_SELECTION,
  SET_SELECT_ATTRIBUTE,
  REMOVE_INVOICE_TO_SELECTION,
  CLEAR_SELECTED_INVOICES,
  SET_LOADING_STATS,
  SET_CREDIT,
  SET_BALANCE,
  SET_PORTAUS_COMPANY_ID
};
